<template>
    <div class="cancellation-table">
        <Row v-for="row in rows" :key="row.label" :row="row" />
    </div>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent, PropType } from 'vue';
    import { CancellationTableRow } from './CancellationTable.interfaces';
    import Row from './Row.vue';

    export default defineComponent({
        name: 'CancellationTable',
        methods: { t },
        components: { Row },
        props: {
            rows: {
                type: Array as PropType<CancellationTableRow[]>,
                required: true,
            },
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'CancellationTable';
</style>
